import { Select, Space } from 'antd';
import SurveyGroupSelect from 'components/SurveyGroupSelect';
import useQuestions from 'hooks/useQuestion';
import useSurvey from 'hooks/useSurvey';
import React, { useEffect, useState } from 'react';

const SurveyQuestionSelector = ({ value, onChange, customerId }) => {
  const [surveyId, setSurveyId] = useState();
  const { questions } = useQuestions({ questionIds: value, extraFields: 'survey { id }' });
  const { survey } = useSurvey({ surveyId, extraFields: 'questions { id title }' });

  useEffect(() => {
    if (!surveyId && questions?.length) {
      setSurveyId(questions[0]?.survey?.id);
    }
  });

  const questionOptions = survey?.questions?.map((question) => ({ label: question.title, value: question.id }));

  return (
    <Space>
      <SurveyGroupSelect value={surveyId} onChange={setSurveyId} customerId={customerId} selectables={['survey']} showStatus={false} />
      <Select options={questionOptions} value={value} onChange={onChange} style={{ minWidth: 200 }} mode="multiple" />
    </Space>
  );
};

export default SurveyQuestionSelector;
